import {LinkProps} from 'platform/foundation';

type LabelAction = Pick<
  LinkProps,
  'title' | 'leftIcon' | 'onClick' | 'isDisabled' | 'href' | 'target' | 'rightIcon'
>;
export type LabelActions = LabelAction[];
